import Grid from '@/global/components/ui/Grid'
import { Checkbox, Divider, FormControlLabel } from '@mui/material'
import {
    FormDatePicker,
    FormField,
    FormFieldCheckbox,
} from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'

export const BancoHoras = () => {
    const { watch, setValue } = useFormContext()

    const [periodoFechamentoPonto] = watch(['periodoFechamentoPonto'])

    const [usarBancoHoras, setUsarBancoHoras] = useState(
        !!periodoFechamentoPonto,
    )

    return (
        <section id="banco-horas">
            <Divider sx={{ mb: 3, userSelect: 'none' }}>Banco de horas</Divider>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <FormField
                        name="diasRescisao"
                        type="number"
                        label="Dias de exibição de funcionários desligados"
                        InputProps={{
                            endAdornment: (
                                <IconeAjuda>
                                    Essa é a quantidade de dias após a rescisão
                                    que os funcionários serão listados em
                                    relatórios e na tela de digitação. Após esse
                                    período, o funcionário não será mais exibido
                                    e será listado apenas em relatórios de
                                    competências anteriores.
                                    <br />
                                    <br />
                                    Esse campo também controla a exibição dos
                                    funcionários na tela de cadastros de centros
                                    de custo.
                                </IconeAjuda>
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={6} className="inline-flex items-center">
                    <FormControlLabel
                        className="select-none px-4 mt-2"
                        control={
                            <Checkbox
                                checked={usarBancoHoras}
                                onChange={({ target: { checked } }) => {
                                    if (!checked) {
                                        setValue('periodoFechamentoPonto', 0)
                                    }

                                    setUsarBancoHoras(checked)
                                }}
                            />
                        }
                        label="Utilizar banco de horas"
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        name="periodoFechamentoPonto"
                        type="number"
                        placeholder="Meses"
                        label="Período de fechamento do ponto (em meses)"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        hidden={!usarBancoHoras}
                        InputProps={{
                            endAdornment: (
                                <IconeAjuda className="mt-1">
                                    Período de fechamento do banco de horas
                                    significa que após o término do período
                                    informado, todas as horas extras e faltas
                                    dos funcionarios serão zeradas, iniciando
                                    assim um novo período de banco de horas.
                                </IconeAjuda>
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormDatePicker
                        name="proximoFechamentoPonto"
                        type="month"
                        label="Competência do próximo fechamento"
                        hidden={!usarBancoHoras}
                    />
                </Grid>
                <Grid item xs={7} className="inline-flex items-center">
                    <FormFieldCheckbox
                        name="exibirSaldoDiario"
                        label="Exibir saldo diário na digitação"
                    />
                    <IconeAjuda>
                        Caso marcado, uma coluna a mais será exibida na tela de
                        digitação de ponto, mostrando a diferença do saldo
                        diário do funcionário (extras - faltas).
                    </IconeAjuda>
                </Grid>
            </Grid>
        </section>
    )
}
